import Head from 'next/head';

type TabTitleProps = {
  page?: string;
};

export function TabTitle(props: TabTitleProps) {
  const { page } = props;

  const title = page ? (
    <title>{`${page} | Sub-Zero & Wolf Philippines`}</title>
  ) : (
    <title>Sub-Zero &amp; Wolf Philippines</title>
  );

  return <Head>{title}</Head>;
}

export default TabTitle;
